import { render, staticRenderFns } from "./BillCard.vue?vue&type=template&id=457d5007&scoped=true"
import script from "./BillCard.vue?vue&type=script&lang=js"
export * from "./BillCard.vue?vue&type=script&lang=js"
import style0 from "./BillCard.vue?vue&type=style&index=0&id=457d5007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457d5007",
  null
  
)

export default component.exports